<template>
  <div></div>
</template>

<script>
import { bootIntercom, INTERCOM_APP_ID } from "@/services/IntercomService";
import { getUserProfile } from "@/services/UserService";

export default {
  name: "Intercom",

  mounted() {
    getUserProfile().then((profile) => {
      bootIntercom({
        app_id: INTERCOM_APP_ID,
        email: profile.email,
        user_hash: profile.intercomToken,
        vertical_padding: 85,
      });
    });
  },
};
</script>

<style scoped></style>
